const dealColumns = [
    {
        title: 'Código',
        allowedExcept: [],
    },
    {
        title: 'Cliente',
        data: 'customer_name',
        sortable: true,
        allowedExcept: [],
    },
    {
        title: 'Email',
        allowedExcept: [],
    },
    {
        title: 'Telefone',
        allowedExcept: [],
    },
    {
        title: 'Empreendimento',
        data: 'product_id',
        sortable: true,
        allowedExcept: [],
    },
    {
        title: 'Valor',
        data: 'cost',
        sortable: true,
        allowedExcept: [],
    },
    {
        title: 'Tags',
        data: 'tags',
        sortable: false,
        allowedExcept: [],
    },
    {
        title: 'Origem',
        data: 'origin_id',
        sortable: false,
        allowedExcept: [],
    },
    {
        title: 'Responsável',
        allowedExcept: ['broker'],
    },
    {
        title: 'Etapa - Status',
        data: 'funnel_stage_id',
        sortable: true,
        allowedExcept: [],
    },
    {
        title: 'Data da venda',
        data: 'saled_at',
        sortable: true,
        allowedExcept: [],
    },
    {
        title: 'Atualização',
        data: 'updated_at',
        sortable: true,
        allowedExcept: [],
    },
    {
        title: '',
        allowedExcept: [],
    },
]

const proposalColumns = [
    {
        title: 'Código',
        allowedExcept: []
    },
    {
        title: 'Cliente',
        data: 'customer_name',
        sortable: true,
        allowedExcept: [],
    },
    {
        title: 'CPF',
        allowedExcept: [],
    },
    {
        title: 'Empreendimento',
        data: 'product_name',
        sortable: false,
        allowedExcept: [],
    },
    {
        title: 'Valor',
        data: 'cost',
        sortable: true,
        allowedExcept: [],
    },
    {
        title: 'Responsável',
        data: 'responsible',
        sortable: true,
        allowedExcept: ['broker'],
    },
    {
        title: 'Etapa - Status',
        data: 'funnel_stage_id',
        sortable: true,
        allowedExcept: [],
    },
    {
        title: '',
        class: 'control-xs',
        allowedExcept: [],
    },
]

const reserveColumns = [
    {
        title: 'Código',
        class: 'control-s',
        data: 'id_reserve',
        sortable: true,
    },
    {
        title: 'Data Solicitação',
        data: 'reserve_created_at',
        sortable: true,
    },
    {
        title: 'Solicitado por',
        data: 'requestered_user_name',
        sortable: true,
    },
    {
        title: 'Gerenciado por',
        data: 'managed_user_name',
        sortable: true,
    },
    {
        title: 'Negócio',
    },
    {
        title: 'Responsável pelo Negócio',
        data: 'reserved.first_name',
        sortable: true,
    },
    {
        title: 'Empreendimento',
        data: 'units.availability.product.name',
        sortable: false,
    },
    {
        title: 'Unidade',
    },
    {
        title: 'Etapa / Status',
        data: 'funnel_stage_name',
        sortable: true
    },
    {
        title: 'Status da Reserva',
        data: 'status_reserve',
        sortable: true,
    },
    {
        title: 'Expira em:',
        data: 'order_reservation_expiration_date',
        sortable: true,
    },
    {
        title: 'Corretor',
    },
    {
        title: 'Equipe',
    },
    {
        title: 'Gerente',
    },
    {
        title: 'Fila de Espera',
    },
    {
        title: '',
        class: 'control-xs',
    },
]

export {
    dealColumns,
    proposalColumns,
    reserveColumns
}

